// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ajCs","signatureBlock":"Footer_signatureBlock__3xllE","signature":"Footer_signature__3EMQj"};